import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';

export const getSubtitle = (promo: IPromoInfo): string | null | undefined => {
  const isCianMortgage = promo.promoType === EPromoType.CianMortgage;

  return isCianMortgage ? null : promo.end;
};
